import { render, staticRenderFns } from "./UserPicker.vue?vue&type=template&id=08518ffb"
import script from "./UserPicker.vue?vue&type=script&lang=js"
export * from "./UserPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08518ffb')) {
      api.createRecord('08518ffb', component.options)
    } else {
      api.reload('08518ffb', component.options)
    }
    module.hot.accept("./UserPicker.vue?vue&type=template&id=08518ffb", function () {
      api.rerender('08518ffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/UserPicker.vue"
export default component.exports